module.exports = __webpack_public_path__ + "img/i_mypage_ch.a17cf627.svg";